import angular from 'angular';
import tryClipboardCopy from 'common/services/try-clipboard-copy';

import {} from './od-clipboard-copy.less';

module.exports = angular.module('market.component.od-clipboard-copy', [
])
.component('odClipboardCopy', {
  bindings: {
    text: '@',
    buttonText: '@?',
    showInputElement: '<?',
  },
  template: require('./od-clipboard-copy.jade')(),
  controller: class {
    constructor($element, $timeout) {
      this.$timeout = $timeout;

      this.isHidden = !this.showInputElement;
      this.isSuccess = false;
      this.originalButtonText = this.buttonText || 'Click to copy';
      this.buttonText = this.originalButtonText;

      this.inputEl = $element.find('input')[0];
    }

    copy() {
      this.selectInputText();

      let automaticCopySuccess = tryClipboardCopy();

      if (automaticCopySuccess) {
        this.inputEl.blur();
        this.buttonText = 'Copied!';
        this.isSuccess = true;
        this.$timeout(() => {
          this.buttonText = this.originalButtonText;
          this.isSuccess = false;
        }, 2000);
      } else {
        // If automatic copy failed, we can fall back to asking the user to
        // copy the text manually (via Ctrl/Cmd+C). So we expand the <input>
        // element containing the text, where the text should already be
        // selected and ready to be copied, and prompt the user to copy it.
        this.isHidden = false;
        this.buttonText = 'Copy the selected text';
      }
    }

    selectInputText() {
      this.inputEl.select();
    }
  }
})
.name;




/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-clipboard-copy.js
 **/